import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartment } from "../../../../@types/attendance-local-department";

export function useAttendanceLocalDepartmentDetails(id: AttendanceLocalDepartment["id"]) {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<AttendanceLocalDepartment, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'department', 'details', id],
        queryFn: async () => {
            const response = await apisiseci.get<AttendanceLocalDepartment>(
                `/cms/setor_unidade/${id}/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
    });
}
